import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { format } from 'date-fns';
import './TrackModal.css';

const TrackModal = ({ open, onClose, trackData }) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <Modal show={open} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>Status de Rastreamento</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {Object.keys(trackData).length > 0 ? (
          <ul className="timeline">
            {trackData.historico.map((item, index) => (
              <li key={index} className="timeline-item">
                <div className="timeline-content">
                  <h3>{item.ocorrencia}</h3>
                  <p>Data: {format(new Date(item.dataHora), 'dd/MM/yyyy HH:mm:ss')}</p>
                  <p>Observação: {item.observacao}</p>
                  <p>Recebedor: {item.recebedor}</p>
                  <p>Ação: {item.acao}</p>
                  <p>Produto: {item.produto}</p>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p>Sem ocorrência de transporte</p>
        )}
        <div className="text-center">
          <p>
            <span className="badge bg-info rounded-pill me-2">Previsão de Entrega:</span>
            <span className="d-inline-block fw-bold">{trackData.dtPrevEnt}</span>
          </p>
        </div>




      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TrackModal;
